module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("Also by Homer Hickam")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-paraa"
  }, [_c('em', [_vm._v("Torpedo Junction")]), _c('br'), _c('em', [_vm._v("Rocket Boys")]), _vm._v(" (a.k.a. "), _c('em', [_vm._v("October Sky")]), _vm._v(")"), _c('br'), _c('em', [_vm._v("Back to the Moon")]), _c('br'), _c('em', [_vm._v("The Coalwood Way")]), _c('br'), _c('em', [_vm._v("Sky of Stone")]), _c('br'), _c('em', [_vm._v("We Are Not Afraid")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258089de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0